import { useEffect } from 'react'
import PageHero from '../shared/PageHero'
import TvButton from '../shared/TvButton'
import usePageMeta from '../../utils/usePageMeta'

function NotFound() {
    usePageMeta({ title: 'Page not found', description: 'That page doesn’t exist.', path: '/404' })

    // CloudFront serves index.html with a 200 for unknown paths, so tell crawlers not to index this page
    useEffect(() => {
        const robots = document.createElement('meta')
        robots.name = 'robots'
        robots.content = 'noindex'
        document.head.appendChild(robots)
        return () => robots.remove()
    }, [])
    return (
        <PageHero
            eyebrow="404"
            title="That page doesn’t exist."
            intro="It may have moved during the site redesign."
            actions={
                <>
                    <TvButton text="Go home" to="/" />
                    <TvButton text="Contact me" to="/contact" variant="outline" tone="dark" />
                </>
            }
        />
    )
}

export default NotFound
